import React from 'react';
import { useTranslation } from 'react-i18next';
import theme from '../../../styles/theme';
import useInView from '../../../hooks/useInView';

const steps = [
  { num: '01', key: 'signup' },
  { num: '02', key: 'configure' },
  { num: '03', key: 'operate' },
];

const HowItWorksSection = () => {
  const { t } = useTranslation();
  const [ref, visible] = useInView();

  const s = {
    section: {
      padding: `${theme.spacing['3xl']} ${theme.spacing.xl}`,
      backgroundColor: theme.colors.background.paper,
    },
    inner: {
      maxWidth: '1120px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: theme.spacing['3xl'],
    },
    eyebrow: {
      display: 'inline-block',
      fontSize: theme.typography.fontSize.sm,
      fontWeight: theme.typography.fontWeight.semibold,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: theme.colors.secondary.dark,
      marginBottom: theme.spacing.md,
    },
    h2: {
      fontSize: theme.typography.fluid.h2,
      fontWeight: theme.typography.fontWeight.bold,
      fontFamily: theme.typography.fontFamily.heading,
      color: theme.colors.text.primary,
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: theme.spacing['2xl'],
      position: 'relative',
    },
    step: (i, visible) => ({
      textAlign: 'center',
      opacity: visible ? 1 : 0,
      transform: visible ? 'translateY(0)' : 'translateY(24px)',
      transition: `opacity 0.5s ease ${i * 120}ms, transform 0.5s ease ${i * 120}ms`,
    }),
    num: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '56px',
      height: '56px',
      borderRadius: '50%',
      backgroundColor: theme.colors.primary.main,
      color: '#fff',
      fontSize: theme.typography.fontSize.lg,
      fontWeight: theme.typography.fontWeight.bold,
      marginBottom: theme.spacing.lg,
    },
    title: {
      fontSize: theme.typography.fontSize.xl,
      fontWeight: theme.typography.fontWeight.semibold,
      color: theme.colors.text.primary,
      marginBottom: theme.spacing.sm,
    },
    desc: {
      fontSize: theme.typography.fontSize.sm,
      color: theme.colors.text.secondary,
      lineHeight: theme.typography.lineHeight.relaxed,
      maxWidth: '240px',
      margin: '0 auto',
    },
  };

  return (
    <section style={s.section}>
      <div style={s.inner}>
        <div style={s.header}>
          <span style={s.eyebrow}>{t('public.how.eyebrow', 'Getting started')}</span>
          <h2 style={s.h2}>{t('public.how.heading', 'Up and running in 3 steps')}</h2>
        </div>
        <div style={s.grid} ref={ref} className="how-grid">
          {steps.map(({ num, key }, i) => (
            <div key={key} style={s.step(i, visible)}>
              <div style={s.num}>{num}</div>
              <div style={s.title}>{t(`public.how.${key}.title`, key)}</div>
              <p style={s.desc}>{t(`public.how.${key}.desc`, '')}</p>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        @media (max-width: 700px) { .how-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
};

export default HowItWorksSection;
